import { GaEvents } from '@porterin/booking-flow/src/auth/view/stores/AuthAnalyticsStore';
import { AuthTexts } from '@porterin/booking-flow/src/auth/view/stores/AuthStore';
import { mapPageToCategory } from '@porterin/booking-flow/src/utils/BookingFlowAnalyticsHelper';
import { Button } from '@porterin/component-library/src/base-components';
import { publishEvent } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { isDesktop } from '@porterin/lead-flow/src/components/FareEstimateHelper';
import React from 'react';

const ChangeMobileSection: React.FC<{
  on_change: () => void;
  mobile?: string;
  mobile_code?: string;
}> = ({ on_change, mobile, mobile_code }) => {
  return (
    <div
      className="text-text-lg text-typography-secondary font-normal text-nowrap text-left lg:flex w-full"
      id="change-mobile-section"
    >
      <div>{`${isDesktop() ? AuthTexts.otpModal.otpSentMessage : AuthTexts.otpModal.otpSentMessageFull}`}</div>
      <div className="flex w-full max-lg:mt-[0.2rem]">
        <div className="max-lg:block lg:ml-[0.4rem] font-semibold">{`(${mobile_code}) ${mobile}.`}</div>
        <Button
          className="align-bottom lg:ml-auto ml-4 text-text-lg text-[#0A57FF] font-semibold lg:text-[1.4rem] p-0"
          identifiers={{
            id: 'change-mobile-btn',
          }}
          interactions={{
            onClick: () => {
              publishEvent({
                category: mapPageToCategory(window.location.pathname),
                action: GaEvents.changeNumber,
              });
              on_change();
            },
          }}
        >
          {AuthTexts.otpModal.changeMobile}
        </Button>
      </div>
    </div>
  );
};

export default ChangeMobileSection;
